import {React, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import LoadingIndicator from '../LoadingIndicator';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SortableFilterTable from '../SortableFilterTable';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import cloneDeep from 'lodash/cloneDeep';
import AddEditOrganization from './AddEditOrganization.jsx';
import {
    Card,
    CardContent,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    TableContainer,
    TableCell,
    TableRow,
    Table,
    TableBody,
    Button,
    Paper
}
    from '@mui/material/'

function Organizations(props) {
    const [searchValue, setSearchValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [organizations, setOrganizations] = useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [edittingOrganization, setEdittingOrganization] = useState(null);

    useEffect(() => {
        loadData(); // only called once
    }, []);

    function showLoadingIndicator() {
        return <LoadingIndicator Message={'Loading'} />
    }

    function loadData() {
        setIsLoading(true);
        TokenService.post('', 'Admin_GetOrganizations')

            .then((response) => {
                setIsLoading(false);
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setOrganizations(jsonData);
                 
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
                setIsLoading(false);
            });
    }


    function buildOrgs() {
        if (organizations.length === 0) {
            return (<div>No results</div>)
        }

        let tableData = [];

        /*
        	DonationId = 0;
			DonationTitle = "";
			CompanyName = "";
            CompanyEmail = "";
            PayeeName = "";
            Memo = "";
            CompanyAddress = "";
			CompanyAddress2 = "";
			CompanyCity = "";
			CompanyState = "";
			CompanyZipcode = "";
			CompanyType = "";
            CompanyDescription = "";
            Website = "";
            StartDate = new WCFDate();

            EndDate = new WCFDate();
            Tag = "";
			TotalDonated = 0;
            PaymentMethod = "";
            ACH_RoutingNumber = "";
            ACH_AccountNumber = "";
            ACH_AccountType = "";
            State = "";
            Zipcodes = new List<string>();
            QuickAccessTag = "";
        */
        let columns = [
            {
                name: 'CompanyName',
                mappedProperty: 'CompanyName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Type',
                mappedProperty: 'CompanyType',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'City',
                mappedProperty: 'CompanyCity',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Total',
                mappedProperty: 'TotalDonated',
                dataType: 'money',
                canFilter: true,
                align:'right'
            },

        ]

        return (<div>
            {organizations.map((dataItem, index) => {
                tableData.push(dataItem);
            })
            }
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>Results: {organizations.length}</div>
            <SortableFilterTable data={tableData} columns={columns} expandRow={(data) => handleRowExpanded(data)} uniqueIdentifierProperty={'DonationId'} />
        </div>)
    }

    function handleRowExpanded(org) {
        return <div style={{ backgroundColor: '#efefef', padding: '10px' }}>
            <div>
                <Fab onClick={(e) => setEdittingOrganization(org)} style={{backgroundColor:'var(--sipzee-yellow)'} }><EditIcon /></Fab>
            </div>
            <Card style={{ padding: '10px', maxWidth: '330px', margin: '10px' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14pt', display:'flex', justifyContent:'space-between' }}>
                    <span>Contact</span><ContactPhoneIcon sx={{ color: 'var(--sipzee-green)', alignSelf: 'center' }} />
                </div>
              
                <Table aria-label="organization info table" className='TableRecyclerItem'>
                    <TableBody>
                        <TableRow>
                            <TableCell>Donation Title:</TableCell>
                            <TableCell>{org.DonationTitle}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Company Name:</TableCell>
                            <TableCell>{org.CompanyName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Email:</TableCell>
                            <TableCell>{org.CompanyEmail}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Address</TableCell>
                            <TableCell>
                                <div>
                                    {org.CompanyAddress} {org.CompanyAddress2}
                                </div>
                                <div>{org.CompanyCity} {org.CompanyState}, {org.CompanyZipcode}</div>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Card>

            <Card style={{ padding: '10px', maxWidth: '330px', margin: '10px' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14pt', display: 'flex', justifyContent: 'space-between' }}>
                    <span>Finance</span><MonetizationOnIcon sx={{ color: 'var(--sipzee-green)', alignSelf: 'center' }} />
                </div>

                <Table aria-label="organization info table" className='TableRecyclerItem'>
                    <TableBody>
                        <TableRow>
                            <TableCell>Payment Method:</TableCell>
                            <TableCell>{org.PaymentMethod}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Payee Name:</TableCell>
                            <TableCell>{org.PayeeName == '' ? '[Company Name]' : org.PayeeName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Check Memo:</TableCell>
                            <TableCell>{org.Memo == '' ? '[Default]' : org.Memo}</TableCell>
                        </TableRow>
                        {org.PaymentMethod != 'ACH' ? null :
                            <>
                                <TableRow>
                                    <TableCell>ACH Routing Number</TableCell>
                                    <TableCell>
                                        {org.ACH_RoutingNumber}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>ACH Account Number</TableCell>
                                    <TableCell>
                                        {org.ACH_AccountNumber}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>ACH Account Type</TableCell>
                                    <TableCell>
                                        {org.ACH_AccountType}
                                    </TableCell>
                                </TableRow>
                            </>
                        }
                        <TableRow>
                            <TableCell>TAG:</TableCell>
                            <TableCell>{org.QuickAccessTag}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Card>

            <Card style={{ padding: '10px', maxWidth: '330px', margin: '10px' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14pt', display: 'flex', justifyContent: 'space-between' }}>
                    <span>Zipcodes</span><LocationOnIcon sx={{ color: 'var(--sipzee-green)', alignSelf: 'center' }} />
                </div>
                <div style={{display:'flex', flexWrap:'wrap'} }>
                {org.Zipcodes.map((zip) => {
                    return <div style={{marginLeft:'2px'} }>{zip}</div>
                })}
                </div>
              
            </Card>
        </div>


        /*
            DonationId = 0;
            DonationTitle = "";
            CompanyName = "";
            CompanyEmail = "";
            PayeeName = "";
            Memo = "";
            CompanyAddress = "";
            CompanyAddress2 = "";
            CompanyCity = "";
            CompanyState = "";
            CompanyZipcode = "";
            CompanyType = "";
            CompanyDescription = "";
            Website = "";
            StartDate = new WCFDate();

            EndDate = new WCFDate();
            Tag = "";
            TotalDonated = 0;
            PaymentMethod = "";
            ACH_RoutingNumber = "";
            ACH_AccountNumber = "";
            ACH_AccountType = "";
            State = "";
            Zipcodes = new List<string>();
            QuickAccessTag = "";
        */
    }

    function buildEditOrginization() {
        return <Dialog
            open={true}
            onClose={() => setEdittingOrganization(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ marginLeft: '10px' }}

        >
            <DialogTitle id="alert-dialog-title">
                Edit {edittingOrganization.CompanyName }
            </DialogTitle>
            <DialogContent style={{ height: '90vh', paddingLeft: '5px' }}>
                <AddEditOrganization organization={edittingOrganization} onClose={() => setEdittingOrganization(null)} onSave={(organization) => handleOrganizationSaved(organization)} />
            </DialogContent>
        </Dialog>
    }

    function handleOrganizationSaved(org) {
        let temp = cloneDeep(organizations);
        let isFound = false;
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].DonationId == org.DonationId) {
                isFound = true;
                temp[i] = org;
                break;
            }
        }
        if (!isFound) {
            temp.push(org);
        }
        setOrganizations(temp);
        setEdittingOrganization(null);
    }

    return (

        <div style={{ marginBottom: '200px' }}>
            {isLoading ?
                showLoadingIndicator()
                :

                <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Fab sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => setEdittingOrganization({}) }><AddIcon /></Fab>
                    </div>
                    <div>
                        {buildOrgs()}
                    </div>
                </div>
            }

            {edittingOrganization == null ? null :
                buildEditOrginization()
            }
        </div>
    )
}
export default Organizations;